import { THREE } from '@/three/three.js'

const Colors = {
  black: new THREE.Color(0x333333),
  offWhite: new THREE.Color(0xf0f0f0),
  white: new THREE.Color(0xffffff),
  lightGray: new THREE.Color(0xeaeaea),
  gray: new THREE.Color(0xcacaca),
  darkGray: new THREE.Color(0xaaaaaa),
  abb: new THREE.Color(0xb9508a),
  abbDesat: new THREE.Color(0xbb90a7),
  abbBlue: new THREE.Color(0x00b2a2),
}

const Materials = {
  black: new THREE.MeshBasicMaterial({ color: Colors.black }),
  white: new THREE.MeshBasicMaterial({ color: Colors.white }),
  lightGray: new THREE.MeshBasicMaterial({ color: Colors.lightGray }),
  gray: new THREE.MeshBasicMaterial({ color: Colors.gray }),
  darkGray: new THREE.MeshBasicMaterial({ color: Colors.darkGray }),
  abb: new THREE.MeshBasicMaterial({ color: Colors.abb }),
  abbDesat: new THREE.MeshBasicMaterial({ color: Colors.abbDesat }),
  abbBlue: new THREE.MeshBasicMaterial({ color: Colors.abbBlue }),
}

export { Colors, Materials }
